/** Stratul 3D al orașului pentru macheta de situație, din harta deja adusă în
 *  cadrul desenului (`useOrasInCadru`).
 *
 *  Se construiește numai când se schimbă harta sau lotul — adică identitatea
 *  lui `oras` —, nu la fiecare revizie a soluției (care reface scena machetei,
 *  dar nu mută lotul). Cel vechi se eliberează când vine altul sau când se
 *  închide macheta (`oras` devine `null`). */

import { useEffect, useMemo } from "react";
import { construiesteOras, type StratOras } from "./strat3d";
import type { Oras3 } from "./tipuri";

export function useStratOras(oras: Oras3 | null): StratOras | null {
  const strat = useMemo(() => (oras ? construiesteOras(oras) : null), [oras]);
  useEffect(() => () => strat?.elibereaza(), [strat]);
  return strat;
}
